export const EVERGINE_CANVAS_ID = 'evergine-canvas';
export const EVERGINE_LOADING_BAR_ID = 'evergine-loading-bar';
export const EVERGINE_ASSEMBLY_NAME = 'CirugiasGuiadas.Web';
export const EVERGINE_CLASS_NAME = `${EVERGINE_ASSEMBLY_NAME}.WebEventsListener`;
